import { Handle, Position } from "@xyflow/react";
import { CV } from "@/config/canvasSizing";
import { useCanvasStore } from "@/store/useCanvasStore";

interface ConnectPoint {
  id: string;
  top: string;
  left: string;
  position: Position;
}

const POINTS: ConnectPoint[] = [
  { id: "top-left",     top: "0%",   left: "0%",   position: Position.Top },
  { id: "top",          top: "0%",   left: "50%",  position: Position.Top },
  { id: "top-right",    top: "0%",   left: "100%", position: Position.Top },
  { id: "right",        top: "50%",  left: "100%", position: Position.Right },
  { id: "bottom-right", top: "100%", left: "100%", position: Position.Bottom },
  { id: "bottom",       top: "100%", left: "50%",  position: Position.Bottom },
  { id: "bottom-left",  top: "100%", left: "0%",   position: Position.Bottom },
  { id: "left",         top: "50%",  left: "0%",   position: Position.Left },
];

// Eight connection points around the perimeter (corners + side midpoints) instead of
// one per side — lets a connection start/end anywhere along the border, not just the
// four side midpoints. Rendered edges still float to the nearest boundary intersection
// via getFloatingEdgePoints regardless of which point was grabbed (see edgeUtils.ts).
export default function ConnectableHandles() {
  // Hand (pan) mode is navigation-only: no selection, resize, inspector, or edge
  // creation. Suppress the connection handles entirely so hovering a node can't
  // start an edge (matches NodeResizer/PropertiesPanel gating).
  const activeTool = useCanvasStore((s) => s.activeTool);
  if (activeTool === "hand") return null;

  return (
    <>
      {POINTS.map((p) => (
        <Handle
          key={p.id}
          type="source"
          id={p.id}
          position={p.position}
          style={{
            top: p.top,
            left: p.left,
            width: CV.handle.resizeW,
            height: CV.handle.resizeH,
            transform: "translate(-50%, -50%)",
          }}
          className="!bg-canvas-accent/60 !border-canvas-accent !rounded-full transition-opacity !opacity-0 !pointer-events-none group-hover:!opacity-100 group-hover:!pointer-events-auto"
        />
      ))}
    </>
  );
}
